import { createContext, FC, useContext, useEffect, useMemo } from 'react';

import { useStorage } from '@medly-components/utils';
import { useLocation } from 'react-router-dom';
import { AppointmentFiltersContextType } from './types';

export const defaultAppointmentFilters: AppointmentFiltersContextType = {
    searchQuery: '',
    dates: { startDate: null, endDate: null },
    types: [],
    showArchived: false
};

export const AppointmentFiltersContext = createContext<
    [AppointmentFiltersContextType, React.Dispatch<React.SetStateAction<AppointmentFiltersContextType>>]
>([defaultAppointmentFilters, () => null]);

export const AppointmentFiltersContextProvider: FC = ({ children }) => {
    const { pathname } = useLocation();
    const [filters, setFilters] = useStorage('appointmentFilters', {
        initialValue: defaultAppointmentFilters,
        storage: 'sessionStorage'
    });

    const mappedFilters = useMemo(
        () => ({
            ...filters,
            dates: {
                startDate: filters.dates.startDate ? new Date(filters.dates.startDate) : null,
                endDate: filters.dates.endDate ? new Date(filters.dates.endDate) : null
            }
        }),
        [filters]
    );

    useEffect(() => {
        !pathname.includes('/appointments') && setFilters(defaultAppointmentFilters);
    }, [pathname]);

    return <AppointmentFiltersContext.Provider value={[mappedFilters, setFilters]}>{children}</AppointmentFiltersContext.Provider>;
};

export const useAppointmentFilterContext = () => useContext(AppointmentFiltersContext);
